app.factory('voyageService', [ '$http' ,function($http) {
    return {
        get : function(id) {
        },

        add: function(vessel){
        },

        find: function(filter){
            return $http
            .post('api/voyages/', filter)
            .then(res => {
                return res.data;
            }, errorHandler)
        },

        update: function(vessel){
        },

        remove: function(id){
        }
    };
} ]);
